import {Component, NgModule} from '@angular/core';
import {CommonModule, NgSwitch} from '@angular/common';
import {HttpClient} from "@angular/common/http";
import {FILE_UPLOAD} from "../../constants/apiPaths";
import {MatCard, MatCardContent, MatCardHeader} from "@angular/material/card";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {FormsModule} from "@angular/forms";
import {MatInput} from "@angular/material/input";
import {MatButton, MatButtonModule} from "@angular/material/button";

@Component({
  selector: 'file-report',
  standalone: true,
  imports: [
    NgSwitch,
    MatButtonModule,
    MatCardContent,
    MatLabel,
     FormsModule,
    MatFormField,
    MatCard,
    MatCardHeader,
    MatInput,
    MatButton
  ],
  templateUrl: './file-report.html',
  styleUrl: './file-report.component.scss'
})
export class FileReportModule {
  status: "initial" | "uploading" | "success" | "fail" = "initial"; // Variable to store file status
  file: File | null = null; // Variable to store file

  constructor(private http: HttpClient) {
  }

  ngOnInit(): void {
  }

  // On file Select
  onChange(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.status = "initial";
      this.file = file;
    }
  }

  async onUpload() {
    if (!this.file) return;

    this.status = 'uploading';

    const arrayBuffer = await this.file.arrayBuffer();
    const base64String = this.arrayBufferToBase64(arrayBuffer);

    const payload = {
      filename: this.file.name,
      contentType: this.file.type,
      body: {
        data:base64String
      }
    };

    this.http.post(
            "https://devserver.labbytes.vibytes.com/one-file-gen/religendx",
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/pdf'
        },
        responseType: 'blob'
      }
    ).subscribe({
      next: (blob: Blob) => {
        this.status = 'success';
        this.handleFileSuccess(blob);  // Pass blob, not JSON
      },
      error: (error: any) => {
        console.error(error);
        this.status = 'fail';
      }
    });
  }

  arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  handleFileSuccess(blob: Blob) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'report.pdf';  // Change file name if needed
  link.click();
  window.URL.revokeObjectURL(url); // optional cleanup
}

  private handleError(param: this) {
    return function (p1: any) {
    };
  }
}
